// extracted by mini-css-extract-plugin
module.exports = {"enterFromLeft":"_3Vn27ph3J2YiUpX82ex69A","leftMenu":"_3M_MuzhBoR4Ce4Bj0WiWjl"};